export const ACOMPANHAMENTO_ENDPOINTS = {
  RETOMAR_QUESTIONARIO: "/api/acompanhamento-mensal/questionario/retomar",

  INICIAR_QUESTIONARIO: "/api/acompanhamento-mensal/questionario/iniciar",

  RESPONDER_QUESTIONARIO: "/api/acompanhamento-mensal/questionario/responder",

  VOLTAR_QUESTIONARIO: "/api/acompanhamento-mensal/questionario/voltar",

  FINALIZAR_QUESTIONARIO: "/api/acompanhamento-mensal/questionario/finalizar"
};
